import Swiper, { Autoplay } from 'swiper';
import GLightbox from 'glightbox';

Swiper.use([Autoplay]);

const initSlider = () => {
  new Swiper('.nutrition__slider .swiper', {
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1,
    speed: 10_000,
    loopedSlides: 10,
    freeMode: true,
    keyboard: false,
    pagination: false,
    navigation: false,
    allowTouchMove: false,
    preventClicks: true,
    preventClicksPropagation: true,
    simulateTouch: false,

    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
        // spaceBetween: 30,
      },
      // 1200: {
      //   slidesPerView: 4,
      //   spaceBetween: 30,
      // },
    },
  });

  new Swiper('.nutrition__slider-2 .swiper', {
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1,
    speed: 10_000,
    loopedSlides: 10,
    freeMode: true,
    keyboard: false,
    pagination: false,
    navigation: false,
    allowTouchMove: false,
    preventClicks: true,
    preventClicksPropagation: true,
    simulateTouch: false,

    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
      reverseDirection: true,
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
        // spaceBetween: 30,
      },
      // 1200: {
      //   slidesPerView: 4,
      //   spaceBetween: 30,
      // },
    },
  });
};

const initZoom = () => {
  GLightbox({
    selector: '.nutrition__slide',
    loop: true,
  });

  GLightbox({
    selector: '.nutrition__slide-2',
    loop: true,
  });
};

const nutrition = {
  init: () => {
    initSlider();
    initZoom();
  },
};

export default nutrition;
